import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IMAGES } from '../../data/data';
import { HotelMediaItem, RoomAmenity, RoomTypeRoomItem, RoomTypeRoomItemRoom } from '../../core/api/api.models';
import { CommonModule, getCurrencySymbol } from '@angular/common';

const REPLACE_HOUSEHOLD = '[$XX,000]'

@Component({
  selector: 'app-room-detail',
  standalone: false,
  templateUrl: './room-detail.component.html',
  styleUrls: ['./room-detail.component.sass']
})

export class RoomDetailComponent {
  @Input('roomType') roomType?: RoomTypeRoomItem | null;
  @Input('room') room?: RoomTypeRoomItemRoom | null;
  @Input('images') images?: string[] | null;
  @Output('showInspectionFromDetail') showInspectionFromDetail = new EventEmitter();
  @Output('showFloorPlanFromDetail') showFloorPlanFromDetail = new EventEmitter();
  @Output('closeViewDetail') closeViewDetail = new EventEmitter();
  @Output('closeViewFloorPlan') closeViewFloorPlan = new EventEmitter();
  @Input('visible') visible: boolean = false;

  
  constructor(
    private common: CommonModule,
  ) {

  }

  totalDisplayAmenities = 9;

  getRoomTypeImages() {
    return this.images || [];
  }

  getAspectToString(data: RoomAmenity[]){
    if(data && data.length){
      return data.map(item => item.amenityName).join(', ');
    }
    return '';
  }

  showAllAmenities(roomType: RoomTypeRoomItem){
    roomType.expandAmenities = !roomType.expandAmenities;
  }

  bookAnInspection() {
    this.closeViewDetail.emit();
    setTimeout(() =>  this.showInspectionFromDetail.emit(), 200);

  }

  showFloorPlan() {
    this.closeViewDetail.emit();
    setTimeout(() => this.showFloorPlanFromDetail.emit(), 200)
  }

  getRateType(type: string) {
    if(type.toLowerCase() === 'weekly'){
      return 'Week';
    }
    
    return type;
  }

  formatMoneyNumber(input: number) {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    });
    return formatter.format(input).replace('$', '');
  }

  getHouseHoldDescription(description: string) {
    if(this.room && this.room.minRatePlan) {
      const householdDes = description.replace(REPLACE_HOUSEHOLD, `${getCurrencySymbol(this.room?.minRatePlan.currencyCode.toString(), 'narrow')}${this.formatMoneyNumber(this.room.minRatePlan.roomRate.amount * 52 / 0.3)}`);
      return householdDes;
    }
    return '';
  }
}
